// extracted by mini-css-extract-plugin
module.exports = {"Status":"StatusItem_Status__2fwXE"};